import { createFileRoute, Link } from '@tanstack/react-router'

import { Container } from '@/components/common/container'
import { Seo } from '@/components/common/seo'
import { FadeIn } from '@/components/motion/fade-in'
import { CheckersBoard } from '@/features/play/checkers-board'

export const Route = createFileRoute('/play')({
  component: PlayRoute,
})

function PlayRoute() {
  return (
    <Container className="flex flex-col gap-10 py-10 sm:gap-12 sm:py-14">
      <Seo
        title="Play Checkers Online"
        description="Play a full game of checkers online for free — standard rules, no account, right in your browser."
        path="/play"
      />

      <FadeIn className="flex flex-col gap-3">
        <h1 className="text-display-md sm:text-display-lg text-foreground">Play Checkers</h1>
        <p className="text-muted-foreground max-w-xl text-lg">
          Standard rules, two players sharing one board. New to the game?{' '}
          <Link to={'/rules' as never} className="text-foreground underline underline-offset-4">
            Read the rules
          </Link>
          .
        </p>
      </FadeIn>

      <CheckersBoard />
    </Container>
  )
}
